import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=c1865a0c&scoped=true"
import script from "./drafts.vue?vue&type=script&lang=js"
export * from "./drafts.vue?vue&type=script&lang=js"
import style0 from "./drafts.vue?vue&type=style&index=0&id=c1865a0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1865a0c",
  null
  
)

export default component.exports